import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Card, Table, DatePicker, Button, Input, message, Alert } from "antd";
import moment from "moment";
import {
  req_list_lrs_specialdays,
  req_add_lrs_specialday,
  req_delete_lrs_specialday,
} from "../../api";
import storageUtils from "../../utils/storageUtils";

class SpaceModalSessionTime extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    loading: false,
    description: null,
    specialDate: null,
    space: {},
    specialdays: [],
  };

  static propTypes = {
    space: PropTypes.object.isRequired,
    specialdays: PropTypes.array.isRequired,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    this.api_list_specialdays();
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_add_item = async (item) => {
    //console.log(item);
    const result = await req_add_lrs_specialday(
      item,
      storageUtils.getUser().token
    );
    if (result.status === "success") {
      this.api_list_specialdays();
    } else {
      message.info(result.message);
    }
  };

  api_del_item = async (item) => {
    //console.log(item);
    const { Uid } = item;
    const result = await req_delete_lrs_specialday(
      Uid,
      storageUtils.getUser().token
    );
    if (result.status === "success") {
      this.api_list_specialdays();
    } else {
      message.info(result.message);
    }
  };

  api_list_specialdays = async () => {
    const { RoomCode } = this.props.space;
    const result = await req_list_lrs_specialdays(
      RoomCode,
      storageUtils.getUser().token
    );
    if (result.total) {
      const specialdays = result.total > 0 ? result.data : [];
      this.setState({ specialdays });
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "空間編號",
        dataIndex: "RoomCode",
        width: 40,
        responsive: ["md"],
      },
      {
        title: "作業日期",
        dataIndex: "SpecialDay",
        width: 50,
        responsive: ["md"],
      },
      {
        title: "作業說明",
        dataIndex: "SpecialDescription",
        width: 150,
      },
      {
        title: "操作",
        width: 25,
        render: (item) => {
          const SetDate = new Date(item.SpecialDay);
          const TodayDate = new Date();
          return (
            <>
              <button
                className="btn btn-danger btn-sm"
                onClick={() => this.handle_delete_item(item)}
                disabled={TodayDate > SetDate}
              >
                <i className="fas fa-calendar-times"></i> 刪除
              </button>
            </>
          );
        },
      },
    ];
  };

  disabledDate = (current) => {
    // Can not select days before today and today
    return current && current < moment().endOf("day");
  };

  // 操作互動處理 //////////////////////////////////////////////

  handle_datepicker = (date, dateString) => {
    this.setState({ specialDate: dateString });
  };

  handle_add_item = () => {
    const { specialDate, description } = this.state;
    const { RoomCode } = this.props.space;
    if (specialDate !== null) {
      const item = {
        OperatorId: this.props.user.userCode,
        RoomCode: RoomCode,
        SpecialDay: specialDate,
        RoomStatus: "CLOSE",
        SpecialDescription: description === null ? "公休乙日" : description,
      };
      this.api_add_item(item);
    }
  };

  handle_delete_item = (item) => {
    this.api_del_item(item);
  };

  ////////////////////////////////////////////////////////////

  render() {
    const { RoomCode, RoomTwName } = this.props.space;
    const { loading, specialdays, description } = this.state;
    const title = (
      <>
        <DatePicker
          disabledDate={this.disabledDate}
          onChange={this.handle_datepicker}
        />
        <Input
          placeholder="公休說明，例：整修日"
          style={{ width: 250, margin: "0 5px" }}
          value={description}
          onChange={(event) =>
            this.setState({ description: event.target.value })
          }
        />
        <Button type="primary" onClick={this.handle_add_item}>
          <i
            className="far fa-calendar-plus"
            style={{ marginRight: "2px" }}
          ></i>{" "}
          新增
        </Button>
        <p></p>
      </>
    );
    return (
      <Card title={title}>
        <Alert
          message={
            <div style={{ color: "red", fontSize: "1.3em" }}>
              ({RoomCode}){RoomTwName}
            </div>
          }
          type="success"
        />
        <Table
          dataSource={specialdays}
          columns={this.columns}
          loading={loading}
          rowKey="Uid"
          scroll={{ y: 480 }}
          width="70%"
          pagination={false}
        />
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(SpaceModalSessionTime);
